import React from "react";
import { TagsOutlined } from "@ant-design/icons";
import styles from "./Inventory.module.css";

const CountUpValue = ({ value, duration = 500, decimals }) => {
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    let start = 0;
    const end = Number(value) || 0;
    const steps = duration / 16;
    const inc = end / steps;
    const timer = setInterval(() => {
      start += inc;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else setCount(start);
    }, 16);
    return () => clearInterval(timer);
  }, [value, duration]);

  if (decimals !== undefined) {
    return <span>{count.toFixed(decimals)}</span>;
  }
  return (
    <span>
      {Number.isInteger(Number(value)) ? Math.floor(count) : count.toFixed(3)}
    </span>
  );
};

const InventoryPageHeader = ({
  title = "Report",
  subtitle = "Inventory",
  icon,
  recordCount,
  stats = [],
  visible = true,
  tabs,
  activeTab,
  onTabChange,
  tabColor = "blue",
  // ── Optional list-mode indicator (e.g. Suspense Yes/No/All toggle) ──
  // modeBadge: { text, color, bg, border } — renders a colored pill next
  // to the title/records badge. Pass undefined/null to omit it entirely.
  modeBadge,
  // accentColor: optional — tints the icon circle to match the current
  // mode so the whole header reads as one color story at a glance.
  accentColor,
}) => {
  const hasTabs = Array.isArray(tabs) && tabs.length > 0;

  return (
    <div className={styles.pageHeader}>
      {/* ── Left: icon + title + record badge + mode badge ── */}
      <div className={styles.pageHeaderLeft}>
        <div
          className={styles.pageIconWrap}
          style={accentColor ? { background: accentColor } : undefined}
        >
          {icon ?? <TagsOutlined style={{ color: "#fff", fontSize: 16 }} />}
        </div>
        <div>
          <div className={styles.pageTitleRow}>
            <span className={styles.pageTitle}>{title}</span>
            {visible && recordCount !== undefined && (
              <span className={styles.recordsBadge}>{recordCount} Records</span>
            )}
            {/* {modeBadge && (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                  fontSize: 11,
                  fontWeight: 800,
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  padding: "3px 10px",
                  borderRadius: 999,
                  color: modeBadge.color,
                  background: modeBadge.bg,
                  border: `1px solid ${modeBadge.border}`,
                  marginLeft: 8,
                  whiteSpace: "nowrap",
                }}
              >
                <span
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: modeBadge.color,
                    display: "inline-block",
                    flexShrink: 0,
                  }}
                />
                {modeBadge.text}
              </span>
            )} */}
          </div>
          <div className={styles.pageSubtitle}>{subtitle}</div>
        </div>
      </div>

      {/* ── Center: tab pills (when tabs prop is provided) ── */}
      {hasTabs && (
        <div
          className={`${styles.headerTabs} ${styles[`headerTabs_${tabColor}`] ?? ""}`}
        >
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`${styles.headerTab} ${activeTab === tab.key ? styles.headerTabActive : ""} ${styles[`headerTabActive_${tabColor}`] ?? ""}`}
              onClick={() => onTabChange?.(tab.key)}
            >
              {tab.icon && (
                <span className={styles.headerTabIcon}>{tab.icon}</span>
              )}
              {tab.label}
            </button>
          ))}
        </div>
      )}

      {/* ── Right: stat chips ── */}
      {stats.length > 0 && (
        <div className={styles.statsRow}>
          {stats.map((s, i) => (
            <div className={styles.statChip} key={i}>
              <span
                className={`${styles.statValue} ${styles[`statValue${capitalize(s.color ?? "white")}`] ?? ""}`}
              >
                {/* <CountUpValue value={visible ? s.value : 0} /> */}
                <CountUpValue
                  value={visible ? s.value : 0}
                  decimals={s.decimals}
                />
              </span>
              <span className={styles.statLabel}>{s.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

export default InventoryPageHeader;
